var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{attrs:{"flat":"","tile":"","loading":_vm.loading}},[_c('v-list',_vm._l((_vm.reports),function(report,index){return _c('ReportItem',{key:index,attrs:{"report":report,"id":_vm.schoolClassId}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }